import { ITypeOffer, TypeOffer } from '../models/typeOffer.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';
import {IPostPromote } from '../models/postPromote.model';
import { IPost } from '../models/post.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PostPromoteService {

  constructor(private http: HttpClient) {}


  getPostPromote(page: number, size: number):  Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/promote/post-promote?page=${page}&size=${size}`, {'headers': headers});
}

getPostPromoteFilter(startDate: any, endDate: any ,page: number, size: number): Observable<any> {
  let headers = new HttpHeaders();
  headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  return this.http.get(`${environment.url}/promote/post-promote?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
}

getListPostPromote():  Observable<any> {
  let headers = new HttpHeaders();
  headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  return this.http.get<any>(`${environment.url}/promote/list-promote/`, {'headers': headers});
}

getListPostIdPromote():  Observable<any> {
  let headers = new HttpHeaders();
  headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
  return this.http.get<any>(`${environment.url}/promote/list-postId`, {'headers': headers});
}

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/postPromote` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getPromoteBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/postPromote` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), {'headers': headers});
  }

  savePromote(postPromote: IPostPromote, postId: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/promote/save?postId=${postId}`, postPromote, {'headers': headers});
  }

  // api/postPromote/{id} => date de début et date de fin
  updatePostPromote(postPromote: IPostPromote){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/promote/` + postPromote.id, postPromote, {'headers': headers});
}

  // https://apidev.kahpoo.com/api/postPromote/apply-for-seller => PUT
  validPromote(post: IPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/postPromote/seller/`+ post.id, post, {'headers': headers});
  }

  // api/postPromote/enable/{id}
  enablePromote(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/promote/enable/` + id, {'headers': headers});
  }

    // api/postPromote/enable?postId=
    enablePromoteByPostId(postId: any) {
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
      return this.http.put(`${environment.url}/promote/enable?postId=` + postId, {'headers': headers});
    }

  // api/postPromote/disable/{id}
  disablePromote(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/promote/disable/` + id, {'headers': headers});
  }

  // api/postPromote/disable/{id}
  deletePromoteFromPostId(postId: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/promote?postId=${postId}` , {'headers': headers});
  }

  getByIdPromote(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/promote/` + id, {'headers': headers});
  }

  getBIdPost(postId: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/promote/` + postId, {'headers': headers});
  }

  updatePromote(postPromote: IPostPromote) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/promote/` + postPromote.id, postPromote, {'headers': headers});
  }

  deletePromote(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/promote/` + id, {'headers': headers});
  }

 isIdInHighlightedPosts(id: number): Observable<boolean> {
    return this.getListPostPromote().pipe(
        map(res => {
            return res.some(postPromote => postPromote.postId === id && postPromote.status === true);

        })
    );
}

}
